import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-run-button',
  template: '<button mat-raised-button (click)="button.action($event)">{{button.label}}</button>',
})
export class RunButtonWidget implements OnInit {
  public button;
  public formProperty;
  constructor(){};
  ngOnInit(): void {
  }

}